import qs from "qs";

/* eslint-disable */
/**
 * @template T
 * @typedef {Object} Response
 * @property {T} result
 */

/**
 * @typedef {Object} BannerResponse
 * @property {string} article_id
 * @property {number | null} articles_category_id
 * @property {number} articles_type_id
 * @property {string} content
 * @property {string} cover
 * @property {string | null} file_name
 * @property {string | null} file_url
 * @property {string} image_url
 * @property {number | null} latitude
 * @property {number | null} longitude
 * @property {string | null} location_title
 * @property {string} title
 * @property {boolean} owner_status
 * @property {boolean} renter_status
 * @property {boolean} resident_status
 * @property {boolean} visitor_status
 * @property {string} created_at
 * @property {number} created_by
 * @property {string | null} requested_at
 * @property {number | null} requested_by
 * @property {string | null} updated_at
 * @property {number | null} updated_by
 * @property {string | null} deleted_at
 * @property {number | null} deleted_by
 * @property {string | null} approved_at
 * @property {number | null} approved_by
 * @property {string} publish_at
 */

export class BannerClient {
  /**
   *
   * @param {import('./HTTPClient').HTTPClient} httpClient
   * @param {string} baseURL
   */
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/banners`;
  }

  /**
   * @async
   * @memberof BannerClient
   * @return {import('axios').AxiosPromise<Response<BannerResponse>>}
   */
  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  /**
   * @memberof BannerClient
   * @param {string} id
   */
  get(id) {
    const url = `${this.baseURL}/${id}`;

    return this.httpClient.request("get", url);
  }

  /**
   * @memberof BannerClient
   */
  post() {
    const url = this.baseURL;

    return this.httpClient.request("post", url);
  }

  /**
   *
   * @param {string} id
   */
  delete(id) {
    const url = `${this.baseURL}/${id}`;

    return this.httpClient.request("delete", url);
  }

}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/banner.js